import "./CaptionTitle.scss";

const TitlePanel: React.FC<{ text: string }> = (props) => {
  return (
    <div className="caption-title-wrapper">
      <h1 className="caption-title-wrapper_payload pt-2 pb-3">{props.text}</h1>
    </div>
  );
};

export default TitlePanel;
